import React from 'react';
import { Button, Divider } from '@heroui/react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { FormHeaderProps } from '../types';

const FormHeader: React.FC<FormHeaderProps> = ({ title, subtitle, onBack }) => {
  const { t } = useTranslation('admin');

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-3">
        <Button isIconOnly variant="light" size="sm" onPress={onBack} aria-label={t('common.back')}>
          <X className="w-4 h-4" />
        </Button>
        <div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">{subtitle}</p>
        </div>
      </div>
      <Divider />
    </div>
  );
};

export default FormHeader;
